<template>
  <div
    style="
      padding: 15px;
      border: 1px dashed #dfdfdf;
      position: relative;
      border-radius: 4px;
      height: fit-content;
    "
    :class="{ 'drag-over': idDragover }"
    @dragover="idDragover = true"
    @dragleave="idDragover = false"
    @drop="handleFileDrop"
  >
    <div>
      <div class="d-flex flex-column align-items-center">
        <div class="area-upload text-center">
          <div style="color: #ced4da">
            <i class="far fa-cloud-upload-alt fa-3x"></i>
          </div>
          <p class="fs-sa-14 mt-8 mb-0">
            {{ $t('engine.filemanager.dragDrop', languageEngine) }}
          </p>
          <p class="fs-sa-12 text-muted mt-8 mb-0">
            {{ selectDirectoryID === "document" ? $t('engine.filemanager.docSupport', languageEngine) : $t('engine.filemanager.fileSupport', languageEngine) }}
            {{ selectDirectoryID === "document" ? limitSizeDoc : limitSizeFile }} MB
          </p>
          <b-button
            size="sm"
            style="width: fit-content"
            class="center mt-4"
            variant="blue"
            @click="toggleInput"
            >{{$t('engine.filemanager.btnBrowse', languageEngine)}}</b-button
          >
        </div>
        <!-- <div
          class="error-zone text-center w-100"
          v-show="errorsFilesName.length > 0"
        >
          <b-badge
            class="p-15"
            style="position: relative; width: 95%; background-color: #f9eded;"
          >
            <ul class="error-file pl-0 text-left">
              <li
                style="list-style: none"
                class="text-danger"
                v-for="(error, error_index) in errorsFilesName"
                :key="`errors_${error_index}`"
              >
                {{ getError(error) }}
                <span
                  v-if="error_index === 0"
                  class="text-danger float-right"
                  @click="errorsFilesName = []"
                >
                  <i class="fas fa-times cursor-pointer"></i>
                </span>
              </li>
            </ul>
          </b-badge>
        </div> -->
      </div>
      <b-form-file
        class="position-absolute invisible h-0 w-0"
        :accept="whitelistFileExtension"
        @change="handleFileInput"
        multiple
        ref="files"
        name="files"
        id="files"
        ></b-form-file>
    </div>
  </div>
</template>

<script>
import fileService from "@services/fileService.js";
import { getCancelToken } from "@services/apiService.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      errorsFilesName: [],
      idDragover: false,
      hasUpload: false,
      fileUpload: [],
      cancelTokens: [],
      uploadedFiles: 0,
      rerenderProgress: true,
      countUploadError: 0,
      countUpload: 0,
      isLoadNewImage : false,
      limitSizeFile : 4,//MB
      limitItemFile : 20,
      limitSizeDoc : 50,//MB
      limitItemDoc : 10,
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
    whitelistFile() {
      const img = "JPG, PNG, GIF or WEBP";
      const doc = "DOC, XLS, TXT, PDF or PPT";
      return this.selectDirectoryID === "document" ? doc : img;
    },
    whitelistFileExtension() {
      const img = "image/jpg, image/jpeg, image/png, image/gif, image/webp";
      const doc =
        "text/plain ,application/doc, application/docx, application/msword, application/xls, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation ,application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document ,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/xlsx, application/txt, application/pdf, application/ppt, application/pptx";
      return this.selectDirectoryID === "document" ? doc : img;
    },
  },
  watch: {
    // fileUpload: {
    //   deep: true,
    //   handler() {
    //     this.countUploadUpdate();
    //     this.countUploadErrorUpdate();
    //   },
    // },
  },
  methods: {
    getCancelToken,
    toggleInput() {
      document.getElementById("files").click();
    },
    handleFileDrop(e) {
      this.errorsFilesName = [];
      this.idDragover = false;
      let droppedFiles = e.dataTransfer.files;
      const limit = this.selectDirectoryID === "document" ? this.limitItemDoc : this.limitItemFile;
      if (!droppedFiles) return;
      if (droppedFiles.length > limit) {
        this.errorsFilesName.push("ERROR_FILES_OVER_LIMIT");
        this.$toast.error({
          title: this.$t(
            "engine.common.alert.upload.fail",
            this.languageEngine
          ),
          message: this.$t('engine.filemanager.alert.uploadArea.overlimit',this.languageEngine, {limit}),
        });
        return;
      }
      this.filterFile(droppedFiles);
    },
    handleFileInput(e) {
      this.errorsFilesName = [];
      let files = e.target.files;
      const limit = this.selectDirectoryID === "document" ? this.limitItemDoc : this.limitItemFile;
      if (!files) return;
      if (files.length > limit) {
        this.errorsFilesName.push("ERROR_FILES_OVER_LIMIT");
        this.$toast.error({
          title: this.$t(
            "engine.common.alert.upload.fail",
            this.languageEngine
          ),
          message: this.$t('engine.filemanager.alert.uploadArea.overlimit',this.languageEngine, {limit}),
        });
        return;
      }
      this.filterFile(files);
    },
    filterFile(files) {
      let currentSize = 0;
      this.isLoadNewImage = false;
      this.fileUpload = [];
      if ( Math.abs(this.countUpload - this.countUploadError) === this.uploadedFiles ) {
        this.hasUpload = true;
        this.uploadedFiles = 0;
        this.countUpload = 0;
        this.$emit("countUpload", this.countUpload);
      }
      
      this.$emit("hasUpload", this.hasUpload);
      this.$emit("uploadedFiles", this.uploadedFiles);
      const limitSize = this.selectDirectoryID === "document" ? this.limitSizeDoc : this.limitSizeFile;
      [...files].forEach((file) => {
        file.error = "";
        if (this.whitelistFileExtension.search(file.type) === -1) {
          file.error = "ERROR_FILES_TYPE";
        } else {
          // Convert to KB.
          const size = file.size / 1024 / 1024;
          if (size < limitSize) {
            currentSize = currentSize + size;
          } else {
            file.error = "ERROR_FILES_SIZE";
          }
        }
        file.dictoryID = this.selectDirectoryID;
        file.id = undefined;
        file.uploadPercentage = 0;
        file.status = "pending";
        file.preview = "";
        this.fileUpload.push(file);
      });
      this.errorsFilesName = [...new Set(this.errorsFilesName)];
      if (this.fileUpload.length <= 0) return;
      if (currentSize + this.disk.used > this.disk.all) {
        this.fileUpload = [];
        this.$bvModal.show("modal-limit");
      }
      this.uploadFile();
    },
    uploadFile() {
      this.countUploadUpdate();
      this.countUploadErrorUpdate();
      this.$emit("fileUpload", this.fileUpload);
      document.getElementById("files").value = null;
      const id = this.selectDirectoryID;
      const type = this.selectDirectoryID === "document" ? "document" : "image";
      const name = this.selectDirectoryName;
      this.fileUpload
        .filter((file) => !file.error)
        .map((file, index_file) => {
          var formData = new FormData();
          formData.append("folderID", id);
          formData.append("folderName", name);
          formData.append("type", type);
          formData.append(`content`, file);

          const cancelToken = this.getCancelToken();
          this.cancelTokens[index_file] = cancelToken;
          fileService
            .uploadfiles(
              formData,
              (event) => {
                file.status = "uploading";
                file.uploadPercentage =
                  Math.round((event.loaded * 100) / event.total) * 0.9;
                // this.countUploadUpdate();
                // this.countUploadErrorUpdate();
                this.rerenderProgress = false;
                this.$emit("rerenderProgress", this.rerenderProgress);
                this.$nextTick(function () {
                  this.rerenderProgress = true;
                  this.$emit("rerenderProgress", this.rerenderProgress);
                });
                if (file.uploadPercentage == 90) {
                  file.status = "uploaded";
                }
              },
              { cancelToken }
            )
            .then((result) => {
              if (result.id) {
                // this.countUploadUpdate();
                // this.countUploadErrorUpdate();
                file.id = result.id;
                file.status = "done";
                file.uploadPercentage = 100;
                this.uploadedFiles += 1;
                if(this.uploadedFiles > Math.abs(this.countUpload - this.countUploadError)) {
                  this.uploadedFiles = Math.abs(this.countUpload - this.countUploadError);
                }
                this.$emit("uploadedFiles", this.uploadedFiles);
                if (Math.abs(this.countUpload - this.countUploadError) === this.uploadedFiles) {
                  this.$emit("getDisk");
                  this.$bvModal.hide("modal-confirm-cancel");
                  this.$emit("callback");
                  if (this.countUploadError === 0) {
                    this.$toast.success({
                      title: this.$t(
                        "engine.common.alert.success.title",
                        this.languageEngine
                      ),
                      message: this.$t('engine.filemanager.alert.uploadArea.success',this.languageEngine, {count:this.countUpload}),
                    });
                  } else {
                    this.$toast.error({
                      title: this.$t(
                        "engine.common.alert.error.title",
                        this.languageEngine
                      ),
                      message: this.$t('engine.filemanager.alert.uploadArea.failGroup',this.languageEngine,{countUploadError:this.countUploadError,countUpload:this.countUpload}),
                    });
                  }
                  if (!this.isLoadNewImage) {
                    this.isLoadNewImage = true;
                    this.$store.dispatch("design/page/initImagesID");
                  }
                }
              } else {
                file.status = "error";
                file.error = "ERROR_UPLOAD_INTERRUPT";
              }
            })
            .catch(() => {
              file.status = "error";
              file.error = "ERROR_UPLOAD_CANCEL";
              // this.countUploadUpdate();
              // this.countUploadErrorUpdate();
              this.rerenderProgress = false;
              this.$emit("rerenderProgress", this.rerenderProgress);
              this.$nextTick(function () {
                // this.countUploadUpdate();
                this.countUploadErrorUpdate();
                this.rerenderProgress = true;
                this.$emit("rerenderProgress", this.rerenderProgress);
              });
            });
        });

      if (this.countUploadError === this.countUpload && this.countUpload > 0) {
        this.$toast.error({
          title: this.$t(
            "engine.common.alert.error.title",
            this.languageEngine
          ),
          message: this.$t('engine.filemanager.alert.uploadArea.fail',this.languageEngine),
        });
      }
    },
    countUploadUpdate() {
      this.$nextTick(function () {
        let upload = this.countUpload;
        if(Math.abs(this.countUpload - this.countUploadError) != this.uploadedFiles) {
          upload = upload + this.fileUpload.length;
        }else{ 
          upload = this.fileUpload.length;
        }
        this.$emit("countUpload", upload);
        this.countUpload = upload;
      });
    },
    countUploadErrorUpdate() {
      this.$nextTick(function () {
        const errors = this.fileUpload.filter((file) => file.error).length;
        this.$emit("countUploadError", errors);
        this.countUploadError = errors;
      });
    },
    cancelUploads() {
      this.hasUpload = false;
      this.visible = true;
      this.$emit("uploadedFiles", this.uploadedFiles);
      this.cancelTokens.map((cancel) => {
        cancel.cancel('CANCEL');
      });
      this.$emit("callback");
    },
    cancelRequest(index) {
      this.cancelTokens[index].cancel('CANCEL');
    },

    getError(error) {
      let text = "";
      const limitSize = this.selectDirectoryID === "document" ? this.limitSizeDoc : this.limitSizeFile;
      const limit = this.selectDirectoryID === "document" ? this.limitItemDoc : this.limitItemFile;

      switch (error) {
        case "ERROR_FILES_TYPE":
          text = `Invalid extension file. Only "${this.whitelistFile}" files are supported.`;
          break;
        case "ERROR_FILES_SIZE":
          text = `Maximum upload file size ${limitSize} MB.`;
          break;
        case "ERROR_UPLOAD_CANCEL":
          text = `Cancel upload this file.`;
          break;
        default:
          text = `System Limit on number of files to upload ${limit} files per time.`;
          break;
      }
      return text;
    },
    setHasUpload(value) {
      this.hasUpload = value;
      this.$emit("hasUpload", this.hasUpload);
    },
  },
  props: {
    selectDirectoryName: {
      type: String,
      default: "system",
    },
    selectDirectoryID: {
      type: [String, Number],
      default: "defaule",
    },
    disk: {
      type: Object,
      default: () => {
        return {
          package: "Unlimited",
          all: 99999,
          used: 0,
        };
      },
    },
  },
};
</script>

<style></style>
